// extracted by mini-css-extract-plugin
module.exports = {"modalModal":"Editor_modalModal__JF_kv","header":"Editor_header__318h_","buttons":"Editor_buttons__2DczS"};